<div class="">
  <div class="wrap_body mt-4">
    <div class="">
      <div>
        <form [formGroup]="userFilterForm">
          <div class="filter-section px-3 m-filter">
            <mat-form-field class="mr-5">
              <mat-label> Name </mat-label>
              <input
                matInput
                autocomplete="off"
                formControlName="name"
                type="text"
                placeholder="Search Name"
              />
            </mat-form-field>
            <div>
              <mat-form-field class="status">
                <mat-label>Report Type</mat-label>
                <mat-select formControlName="reportType">
                  <mat-option value="all">All </mat-option>
                  <mat-option value="valueTest">Valuetest Reports</mat-option>
                  <mat-option value="compCheck">Compcheck Reports</mat-option>
                  <mat-option value="smartResearch">Smart Research Reports</mat-option>
                </mat-select>
              </mat-form-field>
                <span class="reports-label">Reports</span>
                <span class="active-duration-label">Created in the last</span>
              <mat-form-field class="active-duration-value">
                <input
                  type="number"
                  formControlName="duration"
                  matInput
                  (input)="(selectDuration)"
                  [(ngModel)]="inputValue"
                  (ngModelChange)="onInputChange()"
                />
                <mat-error *ngIf="userFilterForm.get('duration').hasError('pattern')" class="invalid-feedback">
                  Please enter a valid number</mat-error
                >
              </mat-form-field>
              <mat-error *ngIf="!isHourDurationValid || !isMinuteDurationValid" class="invalid-feedback ml-0 error-pos">
                Please enter a valid number</mat-error
              >
            </div>
            <mat-form-field class="active-duration-type">
              <mat-select
                formControlName="durationType"
                [(value)]="selectedDurationType"
                (selectionChange)="onDurationTypeChange()"
              >
                <mat-option value="minutes"> Minutes </mat-option>
                <mat-option value="hours"> Hours </mat-option>
                <mat-option value="days"> Days </mat-option>
                <mat-option value="weeks"> Weeks </mat-option>
                <mat-option value="months"> Months </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="status">
              <mat-label>Users</mat-label>
              <mat-select formControlName="userType">
                <mat-option value="all">All </mat-option>
                <mat-option *ngFor="let role of userRoles| keyvalue" [value]="role.key">
                  {{ role.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <button
              color="primary"
              mat-flat-button
              (click)="filterData()"
              [disabled]="isDisableFilterBtn"
              class="ml-auto ml-lg-0"
            >
              Filter
            </button>
            <button mat-button color="primary" class="ml-2" [disabled]="isDisableResetBtn" (click)="resetFilter()">
              Reset
            </button>
          </div>
        </form>
      </div>

      <div class="row mb-5">
        <div class="col-lg-12 mt-2">
          <div class="table_base">
            <div class="table-responsive table_wrap" #clientListContainer>
              <table
                mat-table
                [dataSource]="tableDataSource"
                class="mat-elevation-z2 w-100"
                matSort
                matSortActive="lastActivityDate"
                matSortDirection="desc"
                (matSortChange)="sortTable($event)"
              >
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let element">{{ element.firstName }} {{ element.lastName }}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
                  <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                </ng-container>
                <ng-container matColumnDef="phoneNumber">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Contact Number</th>
                  <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
                </ng-container>
                <ng-container matColumnDef="totalReportsCreated">
                  <th mat-header-cell *matHeaderCellDef>Total Reports Created</th>
                  <td mat-cell *matCellDef="let element">{{ element.reportCount}}</td>
                </ng-container>
                <ng-container matColumnDef="valueTestReports" *ngIf="!hideValueTest">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Valuetest Reports</th>
                  <td mat-cell *matCellDef="let element">{{ element.valueTestReports }}</td>
                </ng-container>
                <ng-container matColumnDef="compCheckReports" *ngIf="!hideCompCheck">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Compcheck Reports</th>
                  <td mat-cell *matCellDef="let element">{{ element?.compCheckReports }}</td>
                </ng-container>
                <ng-container matColumnDef="smartResearchReports" *ngIf="!hideSmartResearch">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Smart Research Reports</th>
                  <td mat-cell *matCellDef="let element">{{ element?.smartResearchReports }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: tableColumnList"></tr>
              </table>
            </div>

            <div class="flex_center w-100" *ngIf="!isDataLoading && !activeUsersCount">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No active users found</h4>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <button
                type="button"
                mat-button
                color="primary"
                [pmx-progress-button]="exportingInProgress"
                (click)="readyToExport()"
                [disabled]="activeUsersCount == 0"
                class="ml-3 m-export"
              >
                <mat-icon [inline]="true">download</mat-icon>
                Export
              </button>
              <mat-paginator
                [length]="activeUsersCount"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="[10, 20]"
                (page)="pageChange($event)"
                showFirstLastButtons
                class="d-inline-block m-wdh"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-in-progress" *ngIf="isDataLoading">
      <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
      Please wait while we load
    </div>
  </div>
  <ng-template #inviteInvestorDialog>
    <button class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </ng-template>
</div>
